<template>
  <div
    class="relative w-full flex-col items-center text-white bg-[#0f0f0f] mt-[20px] pt-[20px] lg:pt-[30px] pb-[40px] lg:pb-[60px]"
  >
    <!-- Scrollable Content Wrapper -->
    <div class="w-full h-full flex flex-col items-center justify-start">
      
      <!-- Promotions Banner Section -->
      <section class="relative w-full max-w-[1300px] mx-auto px-4 pt-8 lg:pt-12">
        <div class="relative w-full h-[110px] md:h-[130px] lg:h-[140px] mb-4 lg:mb-6 overflow-hidden rounded-[20px] flex items-center shadow-xl bg-[#151515] border border-white/5">
          <!-- Background Ambient Glows & Pattern -->
          <div class="absolute top-[-30%] left-[-5%] w-[40%] h-[160%] bg-[#f700ff]/15 blur-[80px] rounded-full pointer-events-none z-0"></div>
          <div class="absolute bottom-[-30%] right-[10%] w-[35%] h-[160%] bg-[#00ffff]/10 blur-[80px] rounded-full pointer-events-none z-0"></div>
          <div class="absolute inset-0 z-0 opacity-[0.03] pointer-events-none" style="background-image: radial-gradient(#ffffff 1px, transparent 1px); background-size: 24px 24px;"></div>
          
          <!-- Text Content -->
          <div class="relative z-10 w-full pl-6 md:pl-10 lg:pl-12">
            <h1 class="text-3xl md:text-4xl lg:text-[42px] font-black tracking-wider uppercase font-sans text-white m-0 leading-[1.1] drop-shadow-md">
              {{ $t("Promotion.Promotions") || 'PROMOTIONS' }}
            </h1>
            <p class="text-[13px] sm:text-[14px] md:text-[15px] text-gray-300 mt-1 font-medium drop-shadow-sm">
              {{ $t('Promotion.Subtext') }}
            </p>
          </div>
        </div>
      </section>

      <!-- Promotions Cards Section -->
      <section id="promotions" class="relative w-full max-w-[1300px] mx-auto px-4">
        <div class="w-full flex flex-col lg:flex-row items-stretch justify-between mt-6 relative z-20 gap-6">
          
          <!-- Left Card (62%): Skin Club +7% Deposit Bonus -->
          <div class="relative w-full lg:w-[62%] lg:h-[490px] rounded-[20px] overflow-hidden flex flex-col md:flex-row items-stretch shadow-lg border border-white/5 bg-[#151515]">
            
            <!-- Background Ambient Glows & Pattern -->
            <div class="absolute top-[-20%] left-[-10%] w-[50%] h-[60%] bg-[#f700ff]/10 blur-[100px] rounded-full pointer-events-none z-0"></div>
            <div class="absolute bottom-[-10%] left-[20%] w-[40%] h-[50%] bg-[#00ffff]/10 blur-[100px] rounded-full pointer-events-none z-0"></div>
            <div class="absolute inset-0 z-0 opacity-[0.03] pointer-events-none" style="background-image: radial-gradient(#ffffff 1px, transparent 1px); background-size: 24px 24px;"></div>

            <!-- Left Side: Text and CTA -->
            <div class="w-full md:w-[50%] p-8 lg:p-10 flex flex-col justify-center z-10">
              <div class="flex flex-col items-start gap-3 w-full">
                <!-- Small Uppercase Label -->
                <span class="text-xs md:text-sm font-black tracking-widest text-[#00ffff] uppercase font-sans">
                  {{ $t('Promotion.ExclusiveOffer') }}
                </span>
                
                <!-- Logo image + Dot + Subtitle -->
                <div class="flex items-center gap-2 flex-wrap">
                  <img src="@/assets/revamp/skin-club-logo.png" alt="SkinClub" class="h-5 md:h-6 w-auto object-contain" />
                  <!-- Dot separator -->
                  <span class="w-1.5 h-1.5 rounded-full bg-white/60 self-center"></span>
                  <!-- Subtitle -->
                  <span class="text-white text-sm md:text-base font-medium tracking-wide">
                    {{ $t('Promotion.PlayWithMore') }}
                  </span>
                </div>
                
                <!-- Headline -->
                <h2 class="text-3xl md:text-4xl lg:text-[38px] font-black tracking-wide text-[#00ffff] font-sans leading-tight mt-1">
                  {{ $t('Promotion.SkinClubHeadline') || 'Get +7% Deposit Bonus' }}
                </h2>
                
                <!-- Promo Code -->
                <div class="text-lg md:text-xl font-extrabold text-[#c6f605] tracking-wide uppercase font-sans">
                  {{ $t('Promotion.UseCode') || 'USE CODE:' }} MAHERCO3
                </div>
                
                <!-- Body Description -->
                <p class="text-white/95 text-sm md:text-base leading-relaxed max-w-md mt-1 font-sans">
                  {{ $t('Promotion.SkinClubDesc') || 'REGISTER NOW TO GET EXCITING REWARDS EVERYDAY!' }}
                </p>
              </div>
              
              <!-- Button -->
              <div class="mt-6">
                <a 
                  href="https://l.skin.club/126MAHERCO1ST" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  class="inline-block text-center bg-[#00e5ff] text-black font-extrabold text-[14px] px-8 py-3 rounded-xl hover:bg-[#00cce6] transition-all shadow-[0_0_20px_rgba(0,229,255,0.4)]"
                >
                  {{ $t('Promotion.RegisterOnSkinClub') || 'REGISTER ON SKIN.CLUB' }}
                </a>
              </div>
            </div>
            
            <!-- Right Side: Flush Full-Height Image -->
            <div class="w-full md:w-[50%] h-[420px] sm:h-[460px] md:h-auto relative overflow-hidden flex items-stretch justify-end z-10">
              <img 
                :src="$i18n.locale === 'ar' ? skinClubArabic : skinClubEnglish" 
                alt="Skin Club +7% Deposit Bonus" 
                class="w-full h-full object-cover object-top"
              />
            </div>
            
          </div>

          <!-- Right Card (38%): Skin Club $2000 Giveaway -->
          <div 
            class="relative w-full lg:w-[38%] lg:h-[490px] rounded-[20px] overflow-hidden flex flex-col justify-between p-6 text-white bg-[#151515] shadow-lg border border-white/5 group"
          >
            <!-- Banner Graphic Image (Whole Image) -->
            <a 
              href="https://maherco.club/011026/?m=v&s=y&b=MAHERCO"
              target="_blank"
              rel="noopener noreferrer"
              class="relative w-full flex-1 min-h-0 rounded-xl overflow-hidden mb-5 flex items-center justify-center bg-black/40 border border-white/10 p-2"
            >
              <img 
                :src="skinClubPromotion" 
                alt="Skin.Club $2000 Giveaway Promotion" 
                class="max-w-full max-h-[380px] lg:max-h-full w-auto h-full object-contain group-hover:scale-105 transition-transform duration-500 rounded-lg" 
              />
            </a>
            
            <!-- Button -->
            <div class="w-full shrink-0">
              <a 
                href="https://maherco.club/011026/?m=v&s=y&b=MAHERCO" 
                target="_blank"
                rel="noopener noreferrer"
                class="block w-full text-center bg-[#6b00b3] text-white font-extrabold text-[14px] px-8 py-3.5 rounded-xl border-2 border-[#a832ff] shadow-[0_0_20px_rgba(107,0,179,0.5)] hover:bg-[#590099] transition-all"
              >
                {{ $t('Promotion.ClaimBonusNow') }}
              </a>
            </div>
          </div>
          
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import skinClubEnglish from "@/assets/revamp/skin-club-english-promotion.webp";
import skinClubArabic from "@/assets/revamp/skin-club-arabic-promotion.webp";
import skinClubPromotion from "@/assets/revamp/skin-club-promotion.webp";

export default defineComponent({
  name: "PromotionPage",
  data() {
    return {
      skinClubEnglish,
      skinClubArabic,
      skinClubPromotion,
    };
  },
});
</script>
